import classNames from 'classnames'
import styles from './styles.module.scss'
import { createUseStyles } from 'react-jss'
import { getColor } from '../../../../assets/Js/modules/styles/styles.module'
import { Icon } from '../../../ui/icons/Icon'
import { Message } from '../../message/Message'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { nanoid } from 'nanoid'
import { useMessage } from '../../../hooks/messages/useMessage'
import {useSelector} from 'react-redux'
import { Context } from '../../../../Context'
import { useStorage } from '../../../hooks/useStorage'
import { ControlSelectedMessages } from '../../message/controlSelectedMessages/ControlSelectedMessages'
import { useRedux } from '../../../hooks/useRedux'
import { SET_CHAT_HISTORY } from '../../../../redux/types'
import { Forms } from '../../forms/Forms'


export const Body = ({activeView=null, ...props}) => {
  //const [MESSAGES, setMESSAGES] = useState([])
  const [history, setHistory] = useState([])
  const [MESSAGES_VIEW, setMESSAGES_VIEW] = useState([])
  const {useMessageHook} = useContext(Context)
  const {REDUCER_DISPASH} = useRedux()
  const chatReducer =  useSelector(state => state.chatReducer)
  const clientDataReducer =  useSelector(state => state.clientDataReducer)
  const selectedFormsReducer =  useSelector(state => state.selectedFormsReducer)
  const [selectionBlock, setSelectionBlock] = useState()
  const trackStrip = useRef()
  const {GetStorage, SetStorage} = useStorage()

  console.warn('Body-component')

  const scrollTrackToBottom = () => {
    const block = trackStrip?.current??null
    if(block) {
      const scrollHeight = block.scrollHeight
      block.scrollTo({top:scrollHeight, behavior:'smooth'})
      console.log('scrollHeight', scrollHeight)
    }
   
  }

  //==>> MESSAGES
  let MESSAGES 
  if(history?.length) {
    let countNum = 0
    MESSAGES = history.map((item, index, arr) => {
      countNum++
      const keyId = nanoid()
      let injectDate = false
      let dayDate = null

      //console.log('item', item)
      
      const prevItem = index>0?arr[index-1]:null
      const nexItem = (index+1<=arr.length-1)?arr[index+1]:null
      const concatMsg = prevItem?.recieved===item?.recieved
      const nextConcatMsg = nexItem?.recieved===item?.recieved
      const type = nexItem?.type??0

      let prevTimestampDate = prevItem?prevItem.timestamp:null
      let prevDate = new Date(prevTimestampDate*1000)

      let messageTimestampDate = item.timestamp
      let messageDate = new Date(messageTimestampDate*1000)

      if(countNum===1||prevDate&&!(prevDate?.getDate()===messageDate?.getDate())&&(prevDate?.getMonth()===messageDate?.getMonth())&&(prevDate?.getFullYear()===messageDate?.getFullYear())) {
        injectDate = true
        const formatter = new Intl.DateTimeFormat('ru', {
          day:'numeric',
          month:'long',
          year:'numeric'
        })
        messageDate = formatter.format(messageDate)
      }

      //console.log('item', item)
      if(history?.length===countNum) {
        //trackStrip?.current?.scrollTo({top:trackStrip?.current?.scrollHeight, behavior:'smooth'})
        scrollTrackToBottom()
      }
      const recieved = item?.recieved??null
      const isMe = (recieved===0)

      const messageData = {
        category:2,
        from:isMe?1:2,
        message: item?.message??'',
        type,
        item
      }
      if(item.message) messageData.message = item?.message??''
      if(item.path) messageData.path = item?.path??''
      
      console.log('history', history, MESSAGES)
      return <Fragment key={keyId}>
        {
          injectDate
            &&
          <Message  
            data={{
              category:1,
              from:3,
              message: messageDate,
              item
            }}
            opt={{

            }}
          />
        }

        <Message  
          data={messageData}
          opt={{
            concatMsg,
            prevItem,
            nextConcatMsg,
          }}

        /> 
      </Fragment>
    })
  }

  useEffect(() => {    
    console.log('chatReduce', chatReducer.history)
    //==>> Get History
    const _history = chatReducer?.history
    if(_history?.length) setHistory(_history)
    setTimeout(()=>scrollTrackToBottom(), 200)
  }, [chatReducer])

  //==>> FORMS
  useEffect(() => {    
    //==>> 
    const siteInfo = clientDataReducer?.site_info??null
    const forms = siteInfo?.forms
    if(forms) {
      const formId = selectedFormsReducer[0]
      const formDate = forms[formId]
      console.log('selectedForm==>', formDate)
      if(MESSAGES?.length) {
        const date = new Date()
        const newHistory = JSON.parse(JSON.stringify(history))
        newHistory.push({
          from:2,
          message: 'Form',
          category:2,
          timestamp: date.getTime(),
          _id:{$id:formId},
          type:7,
          form:formDate
        })
        setHistory(newHistory)
        console.log('newHistory', history, newHistory)
       //REDUCER_DISPASH({type:SET_CHAT_HISTORY, payload:newHistory})
       setTimeout(()=>scrollTrackToBottom(), 200)
      }
    }
    

    console.log('selectedFormsReducer==>', selectedFormsReducer)
    
  }, [selectedFormsReducer])




  // //==>>Form
  // useEffect(() => {   
  //   if(clientDataReducer?.site_info) {
  //     const siteInfo = clientDataReducer.site_info
  //     if(siteInfo?.forms) {
  //       const forms = siteInfo.forms
  //       const formsKeys = Object.keys(forms)
  //       console.log('formsKeys=====>', formsKeys)
  //       if(formsKeys?.length) {
  //         for(let i=0; i<formsKeys.length; i++) {
  //           const form = forms[formsKeys[i]]??null
  //           console.log('forms=i=====>', i, formsKeys[i])
  //           if(form) {
  //             console.log('forms=====>', form)
  //             const history = {
  //               _id: {
  //                 $id: form?.id??null
  //               },
  //               from:2,
  //               type:7,
  //               message:'form',
  //               item:form
  //             }
  //             REDUCER_DISPASH({type:SET_CHAT_HISTORY, payload:history})
  //           }
  //         }
          
  //       }

        
  //     }
  //     console.log('clientDataReducer=====>', clientDataReducer)
  //   }
    
  // }, [clientDataReducer])
  
  


  return (
    <div className={classNames(styles.body)}>
      {
        activeView?
        <div className={classNames(styles.bodyView)}>
          {activeView}
        </div>
        :
        <>
            <ControlSelectedMessages/>
            <div className={classNames(styles.bodyTop)}>
            </div>
            <div className={classNames(styles.bodyTrack)} ref={trackStrip}>
              <div className={classNames(styles.bodyTrackInner)}>
                {MESSAGES} 
              </div>
            </div>
            {useMessageHook.citationsBlock}
        </>
      }
    </div>
  )
}
